define([
	"csi/def/ActionFactory",
	"csi/widget/MessageDialog",
	"./_StateAction"
], function(ActionFactory,MessageDialog,_StateAction) {

	return ActionFactory.declare("ReviewCancel", _StateAction, {
		m_tag: "ReviewCancel",
		confirmAction: MessageDialog.BUTTON_DISCARD
	});
});